window.addEventListener('DOMContentLoaded', (event) => {
    const productDescription = document.querySelector('.product__description');
    const productDescriptionShowMore = document.querySelector('.product__description--show-more');
    const productDescriptionShowMoreButton = document.querySelector('.product__description--show-more a');
    const productDescriptionHeight = productDescription.clientHeight;
    let productDescriptionScrollHeight = productDescription.scrollHeight;
    const descriptionObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        // productDetailsHeight = productDetails.clientHeight;
        productDescriptionScrollHeight = productDescription.scrollHeight;
        if (productDescriptionScrollHeight > productDescription.clientHeight) {
          // console.log('unhiding: productDescriptionShowMore');
          productDescriptionShowMore.classList.remove('hide');
        }
      }
    });
  
    descriptionObserver.observe(productDescription);
  
    let productDescriptionExpanded = false;
    productDescriptionShowMoreButton.addEventListener('click', function(_ev) {
      productDescription.classList.toggle('trim');
      if (!productDescriptionExpanded) {      
        this.innerHTML = 'Weniger anzeigen';          
        productDescription.style.height = productDescriptionScrollHeight;
        productDescriptionExpanded = true;
      } else {
        this.innerHTML = 'Mehr anzeigen';          
        productDescription.style.height = productDescriptionHeight;
        productDescriptionExpanded = false;
      }
    });
  
    const productDetails = document.querySelector('.product__details--grid');
    const productDetailsPage = document.querySelector('.product__details--wrapper .page-width');
    const productDetailsShowMore = document.querySelector('.product__details--show-more');
    const productDetailsShowMoreButton = document.querySelector('.product__details--show-more a');
    const productDetailsHeight = productDetails.clientHeight;
    let productDetailsScrollHeight = productDetails.scrollHeight;
    const detailsObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        // productDetailsHeight = productDetails.clientHeight;
        productDetailsScrollHeight = productDetails.scrollHeight;
        if (productDetailsScrollHeight > productDetails.clientHeight) {
          productDetailsShowMore.classList.remove('hide');
          productDetailsPage.classList.add('truncated');
        }
      }
    });
  
    detailsObserver.observe(productDetails);
  
    let productDetailsExpanded = false;
    productDetailsShowMoreButton.addEventListener('click', function(_ev) {
      if (!productDetailsExpanded) {
        productDetails.style.height = productDetailsScrollHeight + 'px';
        productDetailsPage.classList.remove('truncated');
        console.log('productDetails.style.height: ', productDetails.style.height);
        this.innerHTML = 'Weniger anzeigen';
        productDetailsExpanded = true;
      } else {
        productDetails.style.height = productDetailsHeight + 'px';
        productDetailsPage.classList.add('truncated');
        this.innerHTML = 'Mehr anzeigen';
        productDetailsExpanded = false;
      }
    });
  
  });
  